import styled from "styled-components";
import Variables from "../../../assets/styleVariables";

export const ErrorContainer = styled.div`
  border: ${props =>
    props.borderless ? "0" : "1px solid " + Variables.colors.complementary_400};
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  margin: ${props => (props.inMiddle ? "85px auto 0 auto" : "8px")};
  width: ${props => (props.inMiddle ? "fit-content" : "")};
  .error-icon {
    color: ${Variables.colors.red_600};
    font-size: 24px;
  }
  .error-message-container {
    font-size: ${Variables.font_sizes.x1_medium};
    line-height: 1.6;
    color: ${Variables.colors.complementary_800};
    margin-bottom: 12px;
    margin-top: 16px;
  }
  .action-container {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    & > div {
      font-size: ${Variables.font_sizes.x1_medium};
      button {
        padding: 8px 12px;
      }
    }
  }
`;
